import React from 'react'
import { Link } from "react-router-dom";

export default function ProcessContent() {
  return (
    <>
    <section className="processpage">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-10 col-md-10">
                    <div className="process-head">
                        <h1 className="heading">The Sonam Label Bespoke Journey</h1>

                        <p>At Sonam Label, every bridal or festive ensemble begins with you. We believe your Haldi, Mehendi, or Wedding outfit should reflect your personality, your rituals, and your unique story. From selecting fabrics and palettes to defining embroidery, silhouettes, and embellishments, our couture process is centred around your vision. You share your inspiration, and we transform it into a beautifully crafted, couture level creation made exclusively for you.</p>
                            
                        <p>Our bespoke process combines thoughtful design, hand-embellished artistry, transparent collaboration, and flawless tailoring blending tradition with modern elegance to create an outfit that feels confidently personal and utterly unforgettable.</p>
                    </div>
                </div>

                <div className="col-lg-8 col-md-8">
                    <div className="process-stepbox wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <img src="/image/process-step-1.webp" alt="step" loading="lazy"/>
                        <h2 className='prostep-head'>Give Us a Peek Into Your Style</h2>
                        <p>Tell us about yourself, your event, and the mood you want to create. Share your ideas, references, colours, fabrics, preferred silhouettes, embellishments, and budget. Connect with us via WhatsApp, call, or email whatever feels easiest. Your inspiration guides the creation of a truly personalised outfit.</p>
                    </div>

                    <div className="process-stepbox wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <img src="/image/process-step-2.webp" alt="step" loading="lazy"/>
                        <h3 className='prostep-head'>Approve Your Custom Design Sketch</h3>
                        <p>Our design team translates your vision into a personalised sketch. You’ll review, suggest edits, and approve the design. (A nominal sketch fee is included and adjusted in your final order.) Once approved, you gain access to a dedicated project dashboard to track every detail of your outfit’s journey.</p>
                    </div>

                    <div className="process-stepbox wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <img src="/image/process-step-3.webp" alt="step" loading="lazy"/>
                        <h4 className='prostep-head'>Finalise Details & Production</h4>
                        <p>Confirm your measurements and exact colours we provide fabric swatches for you to choose from. Production begins once details are finalised. Work-in-progress photos are shared and uploaded on your dashboard, so you can follow every stage of creation.</p>
                    </div>

                    <div className="process-stepbox wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <img src="/image/process-step-4.webp" alt="step" loading="lazy"/>
                        <h4 className='prostep-head'>Be Ready to Be Dazzled</h4>
                        <p>Once your outfit is completed, we share final images before dispatch. After payment of balance and shipping (if applicable), your couture creation is hand-packaged and delivered to your doorstep with love and care.</p>
                    </div>

                    <div className='process-stepbtun'>
                        <Link to={"/contact"} className="default-btn red-default">Start Your Bespoke Journey Today</Link>
                    </div>
                </div>

            </div>
        </div>

        <img src="/image/process-line.webp" className="process-shape" alt="line" loading="lazy"/>
    </section>
    </>
  )
}
